import {
  createContext,
  ReactNode,
  useState,
  SetStateAction,
  Dispatch,
} from "react";

type SmartMenuContextType = {
  smartMenuState: boolean;
  setSmartMenuState: Dispatch<SetStateAction<boolean>>;
  /**
   * El **código** de la entidad abierta (`comercialcmp`, `puntoseco`). Es lo que va en la URL de
   * todas las pantallas del SmartMenu y lo que la API resuelve.
   *
   * No es un nombre, aunque se llame así: la lista de Sellers guardaba acá `record.name` y
   * funcionaba de casualidad, sólo mientras nombre y código coincidieran. "Comercial CMP" salía
   * como `comercial%20cmp` y esa ruta no existe.
   */
  smartMenuName: string;
  setSmartMenuName: Dispatch<SetStateAction<string>>;
  /** Cómo se muestra en el encabezado del menú. Si está vacío, se cae al código. */
  smartMenuLabel: string;
  setSmartMenuLabel: Dispatch<SetStateAction<string>>;
  smartMenuType: string;
  setSmartMenuType: Dispatch<SetStateAction<string>>;
};

const SmartMenuContext = createContext<SmartMenuContextType>({
  smartMenuState: false,
  setSmartMenuState: () => {},
  smartMenuName: "",
  setSmartMenuName: () => {},
  smartMenuLabel: "",
  setSmartMenuLabel: () => {},
  smartMenuType: "",
  setSmartMenuType: () => {},
});

const SmartMenuProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [smartMenuState, setSmartMenuState] = useState(() => {
    const storedValue = localStorage.getItem("smartMenuState");
    return storedValue !== null ? JSON.parse(storedValue) : false;
  });
  const [smartMenuName, setSmartMenuName] = useState(() => {
    const storedValue = localStorage.getItem("smartMenuName");
    return storedValue !== null ? storedValue : "";
  });
  const [smartMenuLabel, setSmartMenuLabel] = useState(() => {
    const storedValue = localStorage.getItem("smartMenuLabel");
    return storedValue !== null ? storedValue : "";
  });
  const [smartMenuType, setSmartMenuType] = useState(() => {
    const storedValue = localStorage.getItem("smartMenuType");
    return storedValue !== null ? storedValue : "";
  });

  const handleSetSmartMenuState: Dispatch<SetStateAction<boolean>> = (
    value,
  ) => {
    setSmartMenuState(value);
    localStorage.setItem("smartMenuState", JSON.stringify(value));
  };

  const handleSetSmartMenuName: Dispatch<SetStateAction<string>> = (value) => {
    setSmartMenuName(value);
    localStorage.setItem("smartMenuName", JSON.stringify(value));
  };

  const handleSetSmartMenuLabel: Dispatch<SetStateAction<string>> = (value) => {
    setSmartMenuLabel(value);
    localStorage.setItem("smartMenuLabel", JSON.stringify(value));
  };

  const handleSetSmartMenuType: Dispatch<SetStateAction<string>> = (value) => {
    setSmartMenuType(value);
    localStorage.setItem("smartMenuType", JSON.stringify(value));
  };

  return (
    <SmartMenuContext.Provider
      value={{
        smartMenuState,
        setSmartMenuState: handleSetSmartMenuState,
        smartMenuName,
        setSmartMenuName: handleSetSmartMenuName,
        smartMenuLabel,
        setSmartMenuLabel: handleSetSmartMenuLabel,
        smartMenuType,
        setSmartMenuType: handleSetSmartMenuType,
      }}
    >
      {children}
    </SmartMenuContext.Provider>
  );
};

export { SmartMenuProvider, SmartMenuContext };
